import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/map';
import fuse from '../../../../_libs/redux-fusion/index';
import {getUserId} from '../../../../auth/reducers';
import {ReduxListStreamedContainer} from '../../../../core-utilities/redux/ReduxListContainer';
import {componentOptions, reduxList} from '../../redux/organizations';
import {buildOrganizationNavigationOptions} from '../../utils/itemActions';
import {AppNavigationOrgsView} from './AppNavigationOrgsView';


const StreamedComponent = (state$, dispatch) => (props$) => {
  const {
    onNavToProjects,
    onItemShowOptions,
  } = buildOrganizationNavigationOptions({
    dispatch,
    selectFirst: true,
  });

  const onClickItem = (e, org) => onNavToProjects(org);

  const userId$ = state$
    .map(getUserId)
    .distinctUntilChanged()
    .takeUntil(props$.last());

  return props$
    .combineLatest(
      userId$,
      (props, userId) => ({
        ...props,
        userId,
        parentId: userId,
        onClickItem,
        onItemShowOptions,
      }));
};

export const ListComponent = ReduxListStreamedContainer(AppNavigationOrgsView, reduxList, componentOptions);
export const AppNavigationOrgsContainer = fuse(StreamedComponent)(ListComponent);



// WEBPACK FOOTER //
// ./src/js/app/navigation/components/AppNavigationOrgs/AppNavigationOrgsContainer.js